<template>
    <b-card no-body>
        <div>
            <b-modal id="cell-create-or-update-modal" :title="editing ? 'Hücre Güncelle' : 'Yeni Hücre Ekle'" size="lg" scrollable no-close-on-esc no-close-on-backdrop v-on:hidden="clearForm">
                <cell-create-or-update v-model="selectedCell" :is-editing="editing" />
                <template #modal-footer>
                    <v-executer :loading="loading" :editing="editing" :action="saveOrUpdate" />
                </template>
            </b-modal>

            <v-table ref="table" :items-provider="provider" :fields="fields" :buttons="buttons" :add-callback="addCell" pagination="server" search />
        </div>
    </b-card>
</template>

<script>
import { BModal, BCard } from "bootstrap-vue";
import { WarehouseApi } from "@/api/warehouse/index.js";
import CellCreateOrUpdate from "./components/CellCreateOrUpdate.vue";

export default {
    name: "CellDefinitionView",
    components: {
        BModal,
        BCard,
        CellCreateOrUpdate,
    },
    data() {
        return {
            loading: false,
            editing: false,
            selectedCell: {},
            fields: [
                { key: "CellCode", name: "Hücre Kodu", sortable: false, thClass: "w-25" },
                { key: "CellName", name: "Hücre Adı", sortable: false, thClass: "w-25" },
                { key: "WarehouseCode", name: "Depo Kodu", sortable: false, thClass: "w-10" },
                { key: "Description", name: "Açıklama", sortable: false, thClass: "w-35" },
            ],
            buttons: [
                { key: "update", icon: "EditIcon", variant: "primary", text: "Güncelle", action: this.editCell },
                { key: "delete", icon: "TrashIcon", variant: "danger", text: "Sil", action: this.deleteCell },
            ],
        };
    },
    methods: {
        async provider(ctx) {
            this.$refs.table.setLoading(true);
            try {
                const requestPayload = {
                    Name: ctx.QueryParam,
                    Skip: ctx.Skip,
                    Take: ctx.Take,
                };

                const response = await WarehouseApi.getListCellLocation(requestPayload);

                const items = response.data.Data.Items || [];
                const total = response.data.Data.Count || 0;

                this.$refs.table.setItems(items);
                this.$refs.table.setTotal(total);
            } catch (error) {
                console.error("Hücre listesi alınırken hata oluştu:", error);
                this.$result(null, error);
                this.$refs.table.setItems([]);
                this.$refs.table.setTotal(0);
            } finally {
                this.$refs.table.setLoading(false);
            }
        },

        deleteCell(item) {
            this.$bvModal
                .msgBoxConfirm(`'${item.CellName || item.CellCode}' adlı hücreyi silmek istediğinize emin misiniz?`, {
                    title: "Lütfen Onaylayın",
                    okVariant: "danger",
                    okTitle: "Tamam",
                    cancelTitle: "Vazgeç",
                    cancelVariant: "dark",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        WarehouseApi.deleteCellLocation(item.Id)
                            .then((res) => {
                                this.$result(res);
                                if (res.data.Success) {
                                    this.$refs.table.refresh();
                                }
                            })
                            .catch((err) => this.$result(null, err));
                    }
                });
        },

        addCell() {
            this.editing = false;
            this.selectedCell = {};
            this.$bvModal.show("cell-create-or-update-modal");
        },
        editCell(item) {
            this.editing = true;
            this.selectedCell = { ...item };
            this.$bvModal.show("cell-create-or-update-modal");
        },
        saveOrUpdate() {
            this.loading = true;

            const promise = this.editing ? WarehouseApi.updateCellLocation(this.selectedCell) : WarehouseApi.createCellLocation(this.selectedCell);

            promise
                .then((res) => {
                    this.$result(res);
                    if (res.data.Success) {
                        this.$bvModal.hide("cell-create-or-update-modal");
                        this.$refs.table.refresh();
                    }
                })
                .catch((err) => this.$result(null, err))
                .finally(() => {
                    this.loading = false;
                });
        },
        clearForm() {
            this.editing = false;
            this.selectedCell = {};
        },
    },
};
</script>
